import { theme } from 'antd';

/**
 * A single chat bubble. User messages are right-aligned with a primary
 * background; assistant messages are left-aligned with a neutral background.
 */
export default function MessageBubble({ role, children }) {
  const { token } = theme.useToken();
  const isUser = role === 'user';

  return (
    <div
      className={`flex w-full ${isUser ? 'justify-end' : 'justify-start'}`}
      style={{ marginBottom: 12 }}
    >
      <div
        style={{
          maxWidth: '85%',
          padding: '8px 12px',
          borderRadius: 12,
          borderTopRightRadius: isUser ? 4 : 12,
          borderTopLeftRadius: isUser ? 12 : 4,
          background: isUser ? token.colorPrimary : token.colorFillSecondary,
          color: isUser ? token.colorTextLightSolid : token.colorText,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          lineHeight: 1.5,
        }}
      >
        {children}
      </div>
    </div>
  );
}
